import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const AccessDenied = () => {
  return (
    <div
      style={{ height: "calc(100vh - 82px - 35px)" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div style={{ maxWidth: "100%", width: "30%", height: "30%" }}>
        <div className="row p-0 h-100 w-100 justify-content-center align-items-center">
          <div className="row p-0 w-100 justify-content-center align-items-center">
            <WarningAmberRoundedIcon style={{ fontSize: 120 }} />
            <div style={{ textAlign: "center" }}>
              Access Denied! <br />
              Please contact an admin to gain access to this application.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
